import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* chargeCreateInvoicePdf(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_CREATE_INVOICE_REQUEST
    });

      yield call(Http.post, `charge/create-pdf`, {
        ...action.payload
      });


    yield put({
      type: Constants.GLOBAL_CHARGE_CREATE_INVOICE_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CHARGE_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeCreateInvoicePdf() {
  yield takeEvery(Constants.GLOBAL_CHARGE_CREATE_INVOICE_START, chargeCreateInvoicePdf);
}
